import { getScore } from '../common/scoreHelpers';
import { Secret } from '@internal/backstage-plugin-aws-services';
import { sortSimpleScore } from '../common/sortScoreHelpers';
import { Team } from '@internal/schemas-common';
import { useMemo } from 'react';

import {
  getSecretsScore,
  useGetSecrets,
} from '@internal/backstage-plugin-aws-services';
import { ScoreIndex, SimpleScore } from '@internal/ui-common';

type UseGetScoresProps = {
  teams: Team[];
};

type UseGetScoresResult = {
  scores: ScoreIndex<SimpleScore>[] | undefined;
};

function getTeamFromSecret(secret: Secret): string {
  return secret.Team.toLowerCase();
}

export const useGetSecretScores = ({
  teams,
}: UseGetScoresProps): UseGetScoresResult => {
  const { value: secrets, loading } = useGetSecrets({
    teams: teams,
  });

  const scores = useMemo(() => {
    return getScore<Secret, SimpleScore>(loading, teams, secrets, {
      getTeam: getTeamFromSecret,
      getScore: getSecretsScore,
      sortScore: sortSimpleScore,
    });
  }, [secrets, teams, loading]);

  return { scores: scores };
};
